document.addEventListener('DOMContentLoaded', function () {
    const headings = document.querySelectorAll('.accordion .collapse h1, .accordion .collapse h2, .accordion .collapse h3, .accordion .collapse h5');

    headings.forEach(replaceHeadingsWithH5);

    function replaceHeadingsWithH5(value) {
        const h4 = document.createElement('h4');
        h4.textContent = value.textContent;
        value.replaceWith(h4);
    }
});
